module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-36.fb9f417e.png";